const faqSectionId = window.__faqSectionId;

function initFaq(container) {
  const faqsfaq = container.querySelectorAll('.lp-faq-content');
  faqsfaq.forEach((faq) => {
    const header = faq.querySelector('.lp-faq_header');
    const desc = faq.querySelector('.lp-description');
    const plus = faq.querySelector('.lp-plus_icon');
    const minus = faq.querySelector('.lp-minus_icon');

    if (faq.classList.contains('open')) {
      desc.style.height = `${desc.scrollHeight}px`;
      plus.style.display = 'none';
      minus.style.display = 'inline-block';
    } else {
      desc.style.height = '0px';
      plus.style.display = 'inline-block';
      minus.style.display = 'none';
    }

    header.addEventListener('click', () => {
      const isOpen = faq.classList.contains('open');

      faqsfaq.forEach((other) => {
        other.classList.remove('open');
        other.querySelector('.lp-description').style.height = '0px';
        other.querySelector('.lp-plus_icon').style.display = 'inline-block';
        other.querySelector('.lp-minus_icon').style.display = 'none';
      });

      if (!isOpen) {
        faq.classList.add('open');
        desc.style.height = `${desc.scrollHeight}px`;
        plus.style.display = 'none';
        minus.style.display = 'inline-block';
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector(`.lp-faq_section-${faqSectionId}`);
  if (section) initFaq(section);
});

document.addEventListener('shopify:section:load', function (event) {
  if (event.detail.sectionId !== faqSectionId) return;
  const section = document.querySelector(`.lp-faq_section-${faqSectionId}`);
  if (section) initFaq(section);
});

document.addEventListener('shopify:section:unload', function (event) {
  if (event.detail.sectionId !== faqSectionId) return;
});